import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { isAuthenticated } from './services/auth';
import Login from './pages/Login';
import RequestList from './pages/RequestList';
import Migration from './pages/Migration';
import MigrationItem from './pages/MigrationItem';
import MigrationCreate from './pages/MigrationCreate';
import BotServers from './pages/BotServers';
import ProfileAffinity from './pages/ProfileAffinity';
import AppLayout from './components/layout/AppLayout';

// Protected route component
const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/requests" element={<RequestList />} />
          <Route path="/migration" element={<Migration />} />
          <Route path="/migrations/:id" element={<MigrationItem />} />
          <Route path="/migrations/create" element={<MigrationCreate />} />
          <Route path="/bot-servers" element={<BotServers />} />
          <Route path="/session-routing" element={<ProfileAffinity />} />
        </Route>
        <Route
          path="/"
          element={
            isAuthenticated() ? (
              <Navigate to="/requests" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route path="*" element={<Navigate to="/requests" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
